$(document).ready(function () {
  $("#Slider-Thumbnails-template--22099496632637__main > li").each(function () {
    $(this).find("img").removeAttr("sizes");
  });

  var initialZoomFactor = 1.0;
  var zoomIncrement = 0.0005;
  var containerOffsetTop1 = 0;
  var containerOffsetTop2 = 0;
  if ($("#shopify-section-template--22099496632637__image_banner_z7t3mU .banner__media img").length) {
    containerOffsetTop1 = $(
      "#shopify-section-template--22099496632637__image_banner_z7t3mU .banner__media img"
    ).offset().top;
  }

  if ($("#shopify-section-template--22099496632637__image_with_text_BraYbK .image-with-text__media-item .image-with-text__media").length) {
    containerOffsetTop2 = $(
      "#shopify-section-template--22099496632637__image_with_text_BraYbK .image-with-text__media-item .image-with-text__media"
    ).offset().top;
  }
  

  var lastScrollTop = 0;
  $(window).scroll(function (e) {
    e.preventDefault();
    sst = $(this).scrollTop();

    if (
      $("#shopify-section-template--22099496632637__image_with_text_ecdxhG")
        .length &&
      $(
        "#shopify-section-template--22099496632637__image_with_text_ecdxhG"
      ).isInViewportBathurst()
    ) {
      var sstpos = "2px";
      if (sst < lastScrollTop) {
        if (sst < 1) {
          sstpos = 0;
        }
        $(
          "#shopify-section-template--22099496632637__image_with_text_ecdxhG .image-with-text__media img"
        ).css("top", "-=" + sstpos);
      } else {
        $(
          "#shopify-section-template--22099496632637__image_with_text_ecdxhG .image-with-text__media img"
        ).css("top", "+=" + sstpos);
      }
    }

    if (
      $("#shopify-section-template--22099496632637__image_banner_z7t3mU")
        .length &&
      $(
        "#shopify-section-template--22099496632637__image_banner_z7t3mU"
      ).isInViewportBathurst()
    ) {
      var sscroll = $(this).scrollTop() - containerOffsetTop1;
      scroll1 = Math.max(0, sscroll);
      var zoomFactor = initialZoomFactor + scroll1 * zoomIncrement;
      $(
        "#shopify-section-template--22099496632637__image_banner_z7t3mU .banner__media img"
      ).css({
        transform: "scale(" + zoomFactor + ")",
      });
    }

    if (
      $("#shopify-section-template--22099496632637__image_with_text_BraYbK")
        .length && 
      $("#shopify-section-template--22099496632637__image_with_text_BraYbK")
      .isInViewportBathurst()) 
    {
      var zoomFactor = 1.05; // Facteur de zoom léger, ajustez selon besoin
      var currentScale = parseFloat($("#shopify-section-template--22099496632637__image_with_text_BraYbK .image-with-text__media img").css('transform').split(',')[3]); 
      if (sst < lastScrollTop) {
          // Défilement vers le haut
          if (currentScale > 1) { // Empêche de dézoomer en dessous de l'échelle normale
              currentScale /= zoomFactor; // Réduit légèrement le zoom
          }
      } else {
          // Défilement vers le bas
          currentScale *= zoomFactor; // Augmente légèrement le zoom
      }
      $("#shopify-section-template--22099496632637__image_with_text_BraYbK .image-with-text__media img").css("transform", "scale(" + currentScale + ")");
  }



    lastScrollTop = sst;
  });
});

$.fn.isInViewportBathurst = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};
